import EmployeeHeadcountFilter from "../../components/filters/EmployeeHeadcountFilter/EmployeeHeadcountFilter";
import EmployeeHeadcountFilterResult from "../../components/filters/EmployeeHeadcountFilter/EmployeeHeadcountFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindEmployeeHeadcountFilter from "./EmployeeHeadcountFilter";

export const employeeHeadcountDefinition = defineDescriptionFilter({
    key: "employeeHeadcount",
    apiCategory: leadsFilterApiCategory.employeeHeadcount,
    category: leadsFilterCategoryMap.company,
    trackingName: "Employee Headcount",
    titleKey: { key: "si.lead_gen_filters.group.employeeHeadcount.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.employeeCount.tooltip" },
        filter: new FindEmployeeHeadcountFilter({
            options: description.employeeHeadcountGroups,
        }),
        filterView: EmployeeHeadcountFilter,
        filterResultView: EmployeeHeadcountFilterResult,
    }),
});
